import { DefaultError, useQuery } from '@tanstack/react-query';
import { apiClient } from 'utils';
import { useResponseHandler } from 'utils/service/responseHandler';
import { USER_SOURCE } from './types';

export const useGetUserSource = (email: string) => {
  const { responseHandler } = useResponseHandler();
  return useQuery<{ id: USER_SOURCE }, DefaultError>({
    queryKey: ['artist', email],
    async queryFn() {
      const response = await apiClient({
        method: 'GET',
        url: `Auth/Source`,
        params: { email },
      });

      return responseHandler(response, {
        groupName: 'useGetUserSource',
        onNotFound: () => {},
      });
    },
  });
};
